import * as React from "react";
import { Form, useFormApi } from "informedv4";
import DocumentTitle from "../../misc/components/DocumentTitle";
import Alert, { AlertCategoryEnum } from "../../misc/components/Alert";
import { Link } from "react-router-dom";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { Authorization } from "../../misc/components/Authorization";
import { useSecurityContext } from "../../Core/SecurityContext";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { useReferenceContextProvider } from "../../Core/ReferenceContextProvider";
import { PopulationGroupFormBody, PopulationGroupFormModel } from "./PopulationGroupFormBody";
import { ActionButtons } from "../../misc/ActionButtons";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";

export const CreatePopulationGroupForm = () => {
    const { countries, study } = useCurrentStudyConfigurationContext();
    const formApi = useFormApi();
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [submitting, setSubmitting] = React.useState(false);
    const [warningAlert, setWarningAlert] = React.useState<string>(null);
    const [errorAlert, setErrorAlert] = React.useState<string>(null);

    const Client = useWebPortalApiClient();

    const onSubmit = async () => {
        setSubmitting(true);
        setSuccessAlert(false);
        setWarningAlert(null);
        setErrorAlert(null);

        formApi.validate();
        const state = formApi.getFormState();

        if (state.invalid) {
            setSuccessAlert(false);
            setSubmitting(false);
            return setErrorAlert("Errors exist on the page");
        }

        try {
            const popGroup = await Client.client.postPopulationGroup(
                {
                    name: state.values.Name as string,
                    race: state.values.CoreRace as string,
                    predictedSetId: state.values.PredictedSet as string,
                    correctionFactor: state.values.CorrectionFactor as number,
                    isDisabled: state.values.Disabled as boolean,
                    studyId: study.id,
                });

            if (popGroup) {
                setSuccessAlert(true);
            }
        } catch (ex) {
            setErrorAlert(ex.message);
        }

        setSubmitting(false);
    };

    return (
        <>
            <Alert show={successAlert} category={AlertCategoryEnum.Success}>
                Saved successfully. Return to{" "}
                <Link to={`/studies/populationgroups/${study.id}`}>Population group list</Link>?
            </Alert>
            <Alert show={warningAlert !== null} category={AlertCategoryEnum.Warning}>
                {warningAlert}
            </Alert>
            <Alert show={errorAlert !== null} category={AlertCategoryEnum.Danger}>
                {errorAlert}
            </Alert>
            <div className="row">
                <div className="col-md-6">
                    <h2 className="text-primary">Create Population Group</h2>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div id="detailsPanel" className="panel panel-primary">
                        <div className="panel-heading">
                            <h4>Details</h4>
                        </div>
                        <div className="panel-body">
                            <PopulationGroupFormBody />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <ActionButtons submitting={submitting} onSaveClick={onSubmit} returnToListRoute={`/studies/populationgroups/${study.id}`} automationIdPrefix="ActionsFooter" />
                </div>
            </div>
        </>
    );
};

export const CreatePopulationGroupScreen = () => {
    const { study } = useCurrentStudyConfigurationContext();
    const { currentUserPermissions } = useSecurityContext();

    return (
        <Authorization studyId={study.id} currentPermissions={currentUserPermissions} permissionIdsAny={[PermissionEnum.CreatePopulationGroups]}>
            <DocumentTitle title="Create Population Group | Vitalograph Web Portal">
                <Form validateOn="submit" noValidate>
                    <CreatePopulationGroupForm />
                </Form>
            </DocumentTitle>
        </Authorization>
    );
}
